import React from 'react';
import IssueBadges from './IssueBadges';
import { formatInTimezone } from '../../../utils/formatInTimezone';
import { formatPercent } from '../summaryFormatters';
import { describeNotTracked, pluralDays } from './issueConstants';

/**
 * ТЗ №2 §7: карточка issue. N — только из list.window_days (applied period).
 * resolved визуально приглушён, но не скрыт. Timestamp — в display_timezone
 * камеры этого issue.
 *
 * ТЗ v4 §30 (FE-FIX27): карточку можно выделить чекбоксом для массового
 * действия, а при not_tracked показывается один блок с причиной. Причина —
 * рядом с состоянием, а не вместо него: проблема с выключенным правилом
 * остаётся активной и не уезжает в архив сама.
 */
const IssueCard = ({ issue, windowDays, onOpen, selected, onToggleSelect }) => {
  const open = () => onOpen(issue.issue_id);
  const notTracked = issue.tracking_state === 'not_tracked'
    ? describeNotTracked(issue.explanation, issue.tracking_reason)
    : null;

  return (
    <div
      data-testid="oi-card"
      className={`oi-card${issue.status === 'resolved' ? ' oi-card--resolved' : ''}${selected ? ' oi-card--selected' : ''}`}
    >
      {onToggleSelect && (
        <label className="oi-card-select">
          <input
            type="checkbox"
            checked={Boolean(selected)}
            onChange={() => onToggleSelect(issue.issue_id)}
          />
          <span className="oi-card-select-text">Выбрать</span>
        </label>
      )}

      <div
        data-testid="oi-card-body"
        className="oi-card-body"
        role="button"
        tabIndex={0}
        onClick={open}
        onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(); } }}
      >
        <div className="oi-card-head">
          <IssueBadges
            status={issue.status}
            severity={issue.severity}
            trend={issue.trend}
            archiveState={issue.archive_state}
          />
        </div>
        <div className="oi-card-title">{issue.rule_name}</div>
        <div className="oi-card-scope">{issue.camera_name} · {issue.object_name}</div>
        <div className="oi-card-zone">{issue.zone_name || 'Общая область контроля'}</div>
        {notTracked && (
          <div className="oi-card-untracked">
            <b>Больше не отслеживается</b>
            <span>{notTracked.reason}</span>
          </div>
        )}
        <div className="oi-card-counts">
          <span><b>{issue.current_window_count}</b> за последние {pluralDays(windowDays)}</span>
          <span><b>{issue.previous_window_count}</b> за предыдущие {pluralDays(windowDays)}</span>
        </div>
        <div className="oi-card-meta">
          <span>Последнее нарушение {formatInTimezone(issue.last_occurrence_at, issue.display_timezone)}</span>
          <span>Непрерывность контроля {formatPercent(issue.control_continuity_percent)}</span>
          {issue.episode_no != null && <span>Эпизод №{issue.episode_no}</span>}
          {issue.archived_at && (
            <span>В архиве с {formatInTimezone(issue.archived_at, issue.display_timezone)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default IssueCard;
